import { Component, inject, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TournamentDetailsService } from '../tournament-details.service';
import { ToastService } from '../../../_core/services/toast.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef } from '@angular/core';
import { WEBSITE_WIDGET_URL } from '../../../../environments/environment';

@Component({
  selector: 'app-tournament-widget-status',
  templateUrl: './tournament-widget-status.component.html',
  styleUrls: ['./tournament-widget-status.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule],
})
export class TournamentWidgetStatusComponent implements OnInit {
  modalController = inject(ModalController);
  tournamentDetailsService = inject(TournamentDetailsService);
  toastService = inject(ToastService);
  translateService = inject(TranslateService);
  destroyRef = inject(DestroyRef);

  @Input() tournament: any;
  
  isWidgetEnabled: boolean = false;
  widgetCodeSnippet: string = '';
  widgetEndpoint: string = WEBSITE_WIDGET_URL || 'https://widget.ioncourt.com';

  constructor() { }

  ngOnInit() {
    this.isWidgetEnabled = this.tournament?.isWidgetEnabled || false;
    this.updateCodeSnippet();
  }

  updateCodeSnippet() {
    if (this.tournament?._id) {
      this.widgetCodeSnippet = `<iframe src="${this.widgetEndpoint}/tournaments/${this.tournament._id}" frameborder="0" height="100%" width="100%"></iframe>`;
    }
  }

  async onToggleChange(event: any) {
    const isEnabled = event.detail.checked;
    
    if (!this.tournament?._id) {
      this.toastService.presentToast(this.translateService.instant('Tournament ID not found'));
      return;
    }

    this.tournamentDetailsService
      .updateWidgetStatus(this.tournament._id, isEnabled)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.isWidgetEnabled = isEnabled;
          this.tournament.isWidgetEnabled = isEnabled;
          this.toastService.presentToast(res.message || this.translateService.instant('Widget status updated'));
        },
        error: (err) => {
          // Revert toggle on error
          event.target.checked = !isEnabled;
          this.toastService.presentToast(this.translateService.instant('Failed to update widget status'));
        }
      });
  }

  async copyCodeSnippet() {
    if (!this.widgetCodeSnippet) return;

    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(this.widgetCodeSnippet);
        this.toastService.presentToast(this.translateService.instant('Code snippet copied to clipboard!'));
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = this.widgetCodeSnippet;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.toastService.presentToast(this.translateService.instant('Code snippet copied to clipboard!'));
      }
    } catch (error) {
      this.toastService.presentToast(this.translateService.instant('Failed to copy code snippet'));
    }
  }

  async modalDissmissed() {
    await this.modalController.dismiss();
  }
}

